// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"5e30e3ba","154":"8a96e72f"}[chunkId] + ".chunk.js";
};